export default {
      id: "command__history-key-usage",
      viewBox: "0 0 44.05 42.35",
      url: __webpack_public_path__ + "img/icons.svg#command__history-key",
      toString: function () {
        return this.url;
      }
    }